import toast from "react-hot-toast";
import axiosInstance from "../../../../axiosInstance";

export const createTourBooking = (
  FormData,
  bookedBy,
  setIsLoading,
  navigate,
) => {
  setIsLoading(true);
  axiosInstance
    .post("/booking/create-tour-booking", {
      FormData,
      bookedBy,
    })
    .then((res) => {
      if (res.status === 201) {
        toast.success("Tour booking created successfully");

        setIsLoading(false);
        navigate(`/tour/booking/success/${FormData.transactionId}`);
      } else {
        toast.error("Something went wrong");
        setIsLoading(false);
      }
    })
    .catch((error) => {
      toast.error("Failed to book the property. Please try again.");
      navigate(`/tour/booking/failed/${FormData.transactionId}`);
    });
};
